import { FC, useState } from 'react';

import { Button } from '@new/common/ui/Button/Button';
import { Input } from '@new/common/ui/Input/Input';
import { Upload } from '@new/common/ui/Upload/Upload';

export interface FileUploadDetails {
  institution: string;
  institutionUrl: string;
}

interface FileUploadStepProps {
  isUploading: boolean;
  onSubmit: (file: File, details: FileUploadDetails) => void;
}

export const FileUploadStep: FC<FileUploadStepProps> = ({ isUploading, onSubmit }) => {
  const [institution, setInstitution] = useState('');
  const [institutionUrl, setInstitutionUrl] = useState('');
  const [file, setFile] = useState<File | null>(null);

  const canContinue = institution.trim().length > 0 && !!file;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <label className="[font-size:var(--fs-p4)]! font-medium text-(--neutral-black-NB1000)!">
          Institution
        </label>
        <Input
          value={institution}
          placeholder="e.g. Arizona State University"
          onChange={(v) => setInstitution(v)}
        />
      </div>

      <div className="flex flex-col gap-2">
        <label className="[font-size:var(--fs-p4)]! font-medium text-(--neutral-black-NB1000)!">
          Institution URL (optional)
        </label>
        <Input
          value={institutionUrl}
          placeholder="e.g. https://asu.edu"
          onChange={(v) => setInstitutionUrl(v)}
        />
      </div>

      <div className="flex flex-col gap-2">
        <label className="[font-size:var(--fs-p4)]! font-medium text-(--neutral-black-NB1000)!">
          Transcript file
        </label>
        <Upload
          accept=".pdf,.jpg,.jpeg,.png"
          currentFile={file}
          onUpload={async (f) => setFile(f)}
          onRemove={() => setFile(null)}
          supportedFormatsText="Supported formats: PDF, JPG, PNG"
          dropzoneClassName="bg-[#FFFDFA]!"
        />
      </div>

      <div className="flex justify-end">
        <Button
          variant="primary"
          disabled={!canContinue || isUploading}
          onClick={() => file && onSubmit(file, { institution, institutionUrl })}
          text={isUploading ? 'Uploading…' : 'Continue'}
        />
      </div>
    </div>
  );
};
